import checkSpecificRole from '../utils/functions/checkSpecificRole'

export default ({
    ROLE_USER: () => checkSpecificRole('ROLE_USER'),
    ROLE_STAFF: () => checkSpecificRole('ROLE_STAFF'),
    ROLE_OWNER: () => checkSpecificRole('ROLE_OWNER'),
    ROLE_MASSIVE_OPERATIONS: () => checkSpecificRole('ROLE_MASSIVE_OPERATIONS'),
})